import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { initAnalytics } from './analytics';
import App from './components/App';
import { FeatureFlagsProvider } from './contexts/FeatureFlagProvider';
import { persistor, store } from './redux/store';
import { attemptEmbedAuth } from './utils/embedAuth';
import { isEmbeddedInOperationsUI, prepareOperationsImpersonation } from './utils/operationsEmbed';

// force reload the page if vite encounters an error dynamically loading a
// module.
window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});

initAnalytics();

const root = ReactDOM.createRoot(document.querySelector('#root')!);

async function bootstrap() {
  if (window.opener && CONFIG.ui.embedUIURL) {
    await attemptEmbedAuth();
  }

  if (isEmbeddedInOperationsUI()) {
    await prepareOperationsImpersonation(store, persistor);
  }

  root.render(
    <Provider store={store}>
      <FeatureFlagsProvider>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </FeatureFlagsProvider>
    </Provider>,
  );
}

bootstrap();
